// this is the page where admin can see all the payments made by customers, payments made to farmers and any other payments made by the admin
// this page will have a table with all the payments made
// this page will have a search bar to search for payments
// this page will have a filter to filter payments by date, amount, payment type, payment status
// this page will have a button to download the payments made
// each row is clickable and will take the admin to the payment details page

import CardTable from "components/Tables/CardTable";
import PaymentsTable from "components/Tables/PaymentsTable";
import React from "react";
import axios from "axios";
import config from "../../config";

// components

export default function Payments() {
    
    const [payments, setPayments] = React.useState([]);
    const [columns, setColumns] = React.useState([
        { label: "Transaction ID", key: "transaction_id", render: (value) => <b>{value}</b> },
        { label: "Payable Type", key: "payable_type", render: (value) => <span>{value}</span> },
        { label: "Payable ID", key: "payable_id", render: (value) => <span>{value}</span> },
        { label: "Amount", key: "amount_paid", render: (value) => <span>{value}</span> },
        { label: "Payment Method", key: "payment_method", render: (value) => <span>{value}</span> },
        { label: "Paid At", key: "payment_date", render: (value) => <span>{value}</span> }
    ]); 
    
    const url = `${config.baseUrl}${config.apiEndpoints.listPayments}`;
    React.useEffect(() => {
        axios.get(url)
            .then((response) => {
                setPayments(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    return (
        <>
            <div className="flex flex-wrap mt-4 bg-white ">
                <CardTable
                    color="light"
                    heading="Payments"
                    route="/admin/payments/create"
                    columns={columns}
                    data={payments}
                />

            </div>
        </>
    );
}
